export default __webpack_public_path__ + "static/media/b-download.3ab2f40f.svg";